


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { format, addDays } from 'date-fns';
import { fr } from 'date-fns/locale';
import { BContainer, BRow, BCol, BButtonGroup, BButton } from 'bootstrap-vue';

interface DateInfo {
  value: string;
  day: string;
  number: string;
  month: string;
}

@Component({
  name: 'bpc-date-selector',
  components: {
    BContainer,
    BRow,
    BCol,
    BButtonGroup,
    BButton,
  },
})
export default class DateSelector extends Vue {
  @Prop(String) readonly value: string;
  @Prop(Number) readonly daysLimit: number;

  get model() {
    return this.value;
  }

  set model(value: string) {
    this.$emit('input', value);
  }

  dates: DateInfo[] = [];

  mounted() {
    this.generateDates();
  }

  generateDates() {
    const today = new Date();
    const limit = this.daysLimit || 0;
    for (let i = 0; i <= limit; i++) {
      const date = addDays(today, i);
      this.dates.push({
        value: format(date, 'yyyy-MM-dd'),
        day: format(date, 'EEE', { locale: fr }).toUpperCase(),
        number: format(date, 'd', { locale: fr }),
        month: format(date, 'MMM', { locale: fr }).toUpperCase(),
      });
    }
    if (!this.model) {
      this.model = this.dates[0].value;
    }
  }

  selectDate(date: DateInfo) {
    this.model = date.value;
  }

  @Watch('daysLimit')
  onFinalLimitChange() {
    this.dates = [];
    this.generateDates();
  }
}
